<template>
  <el-row class="searchPanel">
    <el-col :span="24">
      <el-input placeholder="请输入合作社名称" v-model="keywords" class="input-with-select">
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
    </el-col>
    <transition name="el-zoom-in-center">
      <el-col :span="24" class="content-panel" v-show="contentShow">
        <el-col :span="22" style="border-bottom:1px dashed #fff;line-height: 40px">
          组织名称：<span class="height-light">{{data.sercieOrganizeName}}</span>
        </el-col>
        <el-col :span="2" style="border-bottom:1px dashed #fff;line-height: 40px;cursor:pointer" align="right">
          <span @click="closeContent">X</span>
        </el-col>
        <el-col :span="18" style="line-height: 32px">
          托管合同数：<span class="height-light">{{data.tghtCount}}</span>份
        </el-col>
        <el-col :span="6" style="line-height: 32px;padding-top: 2px;" align="left">
          <el-button type="info" plain size="mini" @click="detail()">清 单</el-button>
        </el-col>
        <el-col :span="24" style="border-bottom:1px dashed #fff;line-height: 32px">
          托管农户数：<span class="height-light">{{data.nhCount}}</span>户
        </el-col>

        <el-col :span="24" style="border-bottom:1px dashed #fff;line-height: 48px">
          托管金额：<span class="height-light">{{data.tgje}}</span>万元
        </el-col>
        <el-col :span="18" style="line-height: 32px;">
          任务面积：<span class="height-light">{{data.tgmj}}</span>亩
        </el-col>
        <el-col :span="6" style="line-height: 32px;padding-top: 2px;" align="left">
          <el-button type="info" plain size="mini" @click="location(data.list)">定 位</el-button>
        </el-col>
      </el-col>
    </transition>
    <el-dialog title="合同清单" :visible.sync="dialogTableVisible">
      <el-table :data="tableData">
        <el-table-column property="a" label="序号" width="50"></el-table-column>
        <el-table-column property="d" label="合同编号" width="150"></el-table-column>
        <el-table-column property="e" label="农户姓名" width="100"></el-table-column>
        <el-table-column property="f" label="托管面积(亩)"></el-table-column>
        <el-table-column property="g" label="托管金额(亩)"></el-table-column>
        <el-table-column property="h" label="托管类型(亩)"></el-table-column>
        <el-table-column property="i" label="签订时间(亩)"></el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          align="center"
          width="150">
          <template slot-scope="scope">
            <el-button size="small" plain>定位</el-button>
            <el-button size="small" plain>预览</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页工具-->
      <el-row style="height: 40px;width: 100%;text-align: right;">
        <el-pagination
          background
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @current-change="currentChange"
          layout="prev, pager, next, jumper"
          :total="totalItems">
        </el-pagination>
      </el-row>
    </el-dialog>
  </el-row>
</template>

<script>
// import API from "../../api/contractManagement/api_contractMap"
import turf from 'turf'
export default {
  name: "cooperative-search",
  data() {
    return {
      keywords: "昌平线农机合作社",
      data: {},
      tableData:[{a:'-',b:'-',c:'-',d:'-',e:'-',f:'-',g:'-',h:'-',i:'-'}],
      contentShow: false,
      dialogTableVisible: false,
      currentPage: 1, /*分页工具当前选中页*/
      pageSize: 10,
      totalItems: 0, /*数据总条数*/
    }
  },
  methods: {

    /*分页工具换页*/
    currentChange(val) {
      this.currentPage = val
      this.query();
    },

    async search() {
      let params = {"serviceOrganizeName": this.keywords};
      let result = await API.serviceQuery(params);
      if (result.code === 0) {
        this.data = result.data;
        this.contentShow = true;
      }
    },

    closeContent: function () {
      this.contentShow = false;
    },

    location: function (wkts) {
      let map = this.GLOBAL.map;
      let that = this;
      let polygon = [];
        let json = JSON.parse(wkts[0].wkt).coordinates[0]
        let arr = [ ]
        arr.push(json[0][0])
        arr.push(json[0][1])

        map.fitBounds(arr)

      wkts.forEach(function (item) {
        let geo = item.wkt;

        that.addLayers(geo);
        let a = JSON.parse(geo.coordinates)

      });

      /*  alert(JSON.stringify(geo.coordinates))*/
      /*map.setCenter([113.5548168, 33.3924534]);*/
    },

    detail: function () {
      this.dialogTableVisible = true;
    },
    addLayers: function (geo) {
      let map = this.GLOBAL.map;
      let uuid = this.uuid();
      let sourceId = "s" + uuid;
      let layerId = "l" + uuid;
      let source = {
        "type": "geojson",
        "data": {
          "type": "Feature",
          "properties": {},
          "geometry": JSON.parse(geo)
        }
      };
      map.addSource(sourceId, source);
      map.addLayer({
        "id": layerId,
        "type": "fill",
        "source": sourceId,
        'paint': {
          "fill-color": "#EEEE00",
          "fill-opacity": 0.8,
          "fill-outline-color": "#ff0e4d"
        }
      });
    },

    uuid: function () {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";
      var uuid = s.join("");
      return uuid;
    }
  }
}
</script>

<style scoped>
  .searchPanel {
    position: absolute;
    top: 20px;
    left: 40px;
    height: auto;
    width: 320px;
  }

  .searchPanel .content-panel {
    color: #fff;
    padding: 20px;
    margin-top: 20px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 8px;
  }

  .height-light {
    margin-right: 5px;
    color: #ff9818;
    font-size: 18px
  }

  /*.searchPanel >>> .el-input-group__append, .el-input-group__prepend {
    background-color: #ec7b4f;
    color: #fff !important;
    vertical-align: middle;
    display: table-cell;
    position: relative;
    border-left: 1px solid #ec7b4f;
    border-right: 1px solid #ec7b4f;
    border-top: 1px solid #ec7b4f;
    border-bottom: 1px solid #ec7b4f;
    border-radius: 0px 6px 6px 0px !important;
    padding: 0 20px;
    width: 1px;
    white-space: nowrap;
  }*/

  /* .searchPanel > > > .el-input__inner {
     -webkit-appearance: none;
     !* background-color: #26243c;*!
     background-image: none;
     border-radius: 6px 0px 0px 6px !important;
     border-left: 1px solid #747171;
     border-right: 1px solid #1e1d1d;
     border-top: 1px solid #747171;
     border-bottom: 1px solid #747171;
     color: #3b3d3f;
     display: inline-block;
     font-size: inherit;
     height: 40px;
     line-height: 40px;
     outline: 0;
     padding: 0 15px;
     -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
     transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
     width: 100%;
   }*/
</style>



// WEBPACK FOOTER //
// src/components/mapElementBox/cooperativeSearch.vue